// Base URL of the Pal Chambers Django REST API.
// Adjust the host/port to match where the backend is served.
const API_BASE_URL = 'https://palapi.cylance.ps/palchambers_api/'; // http://localhost:8000, https://palapi.cylance.ps

export const apiBaseUrl = API_BASE_URL;
export default API_BASE_URL;
